import palx from 'palx'

export const color = palx('02c')

export const font = {
  family: `-apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif`,
  size: '2rem',
  lineHeight: '1.2',
  letterSpacing: '.01em',
  color: color['gray9']
}

export const theme = {
  color,
  font
}



// WEBPACK FOOTER //
// ./src/styles/theme.js